module.exports = __webpack_public_path__ + "static/img/alarm.765a4e73.png";